import React, { useEffect, useState } from "react";
import { getContainer } from "../../ioc/IOCSetup";
import { UserLabel } from "../../http/protocol";
import { UserService } from "../../services/UserService";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { SelectInput } from "../form/SelectInput";
import { Submit } from "../form/Submit";
import { UserActionContainerProps, UpdateActionStatus, UserActionContainer } from "./UserActionContainer";

export const UserLabels: React.FC<UserActionContainerProps> = (props: UserActionContainerProps) => {
    const userService: UserService = getContainer().getUserService();
    const [error, setError] = useState("");
    const [labels, setLabels] = useState<UserLabel[]>([]);
    const [selectedLabel, setSelectedLabel] = useState<UserLabel | undefined>({});
    const [form, setForm] = useState({});

    async function loadData() {
        
        userService.getAllLabels()
            .then((response) => {
                response.sort((a: UserLabel, b: UserLabel) => { return a.value! > b.value! ? 1 : -1; });
                setLabels(response);
            })
            .catch((error) =>{ setError(error.message); });
    }

    useEffect(() => {
        loadData();
    }, []);

    function submit(isAdd: boolean) {
        if (!selectedLabel) return;
        let users = [...props.users || []];
        for (let i = 0; i < users.length; i++) {
            users[i].status = UpdateActionStatus.PENDING;
            users[i].description = `Prepared to ` + (isAdd ? `add ` : `remove `) + ` label "${selectedLabel.value}"`;
            users[i].request = () => new Promise<{ status: string; description: string; response: any; }>(async (resolve, reject) => {
                try {
                    let response = isAdd ? await userService.addUserLabel(users[i].user.id, selectedLabel.id) : await userService.deleteUserLabel(users[i].user.id, selectedLabel.value);
                    resolve({ status: UpdateActionStatus.OK, description: (isAdd ? `Added ` : `Removed`) + ` label "${selectedLabel.value}"`, response: response });
                } catch (error) {
                    resolve({ status: UpdateActionStatus.FAIL, description: "Failed " + (isAdd ? "addding" : "removing") + ` label "${selectedLabel.value}"`, response: error });
                }
            });
        }
        if (props.updateUsers) props.updateUsers(users);
    }

    const ref: FormListener<any> = {
        formDidUpdate: (formModel: any, validationMap: any) => {
            setForm(formModel);
            let newLabel = labels.find((label: UserLabel) => label.id == formModel.labelId);
            console.log("newLabel", newLabel);
            setSelectedLabel(newLabel);
        },
        onSubmit: () => { submit(true); }
    };

    return (
        <UserActionContainer title={"User Labels"} error={error}>
            <Form className="form-horizontal" formListener={ref} modelObject={form} validationMap={{}}>
                <FormGroup className="form-group row">
                    <div className="col-sm-8">
                        <SelectInput className="form-control"
                            model="labelId" optional={true} values={labels}
                            displayValue={(a) => { return a && a.value ? a.value.toString() : ""; }}
                            optionModelValue={(a: UserLabel) => { return a.id; }} />
                    </div>
                    <div className="col-sm-4">
                        <Submit className="btn btn-primary">Add</Submit>
                        <Submit className="btn btn-danger" onClick={(e) => { e.preventDefault(); submit(false); }}
                        >Remove</Submit>
                    </div>
                    <span className={"help-block col"}>Choose a label to remove or add. Current selected label: {selectedLabel && selectedLabel.value}</span>
                </FormGroup>
            </Form>
        </UserActionContainer>
    );
};
